import React from 'react';
import './Footer.less';
import { useDispatch, useSelector } from 'react-redux';
import { applicationSelectors } from '../../../redux/application';
import { push } from 'redux-first-history';
import { useIsCompactLayout } from '../../../helper/LayoutHelper';

const Footer = ({}) => {
    const applicationName = useSelector(applicationSelectors.getApplicationName);
    const imprintConfig = useSelector(applicationSelectors.getImprintConfig);
    const privacyConfig = useSelector(applicationSelectors.getPrivacyConfig);
    const accessibilityConfig = useSelector(applicationSelectors.getAccessibilityConfig);

    const dispatch = useDispatch();
    const isCompactLayout = useIsCompactLayout();

    return (
        <div role={'contentinfo'} className="footer static bottom-0 container mx-auto text-center text-xs mt-1 mb-1 text-gray-600">
            {applicationName}
            {isCompactLayout && <br/>}
            {imprintConfig && imprintConfig.url && (
                <>
                    {!isCompactLayout && (<>&nbsp;|{' '}</>)}
                    <a href={imprintConfig.url} target={'_blank'}>
                        Impressum
                    </a>
                </>
            )}
            {privacyConfig && privacyConfig.url && (
                <>
                    &nbsp;|{' '}
                    <a href={privacyConfig.url} target={'_blank'}>
                        Datenschutz
                    </a>
                </>
            )}
            {(accessibilityConfig?.enabled ?? false) && (
                <>
                    &nbsp;|{' '}
                    <a
                        onClick={(e) => {
                            e.preventDefault();
                            window.open('/accessibility');
                        }}
                        href={'/accessibility'}
                        target={'_blank'}
                    >
                        Erklärung zur Barrierefreiheit
                    </a>{' '}
                </>
            )}
        </div>
    );
};

export default Footer;
